import {CSVLink} from "react-csv";
import React, {useEffect, useState} from "react";
import {Button, Input, Modal, Space, Spin} from "antd";
import {AdminApi} from "../../service";
import { useDownloadLog } from "../../../hooks/useDownloadLog";

export function ExportModal<T extends object>(args: {
  fetch: () => Promise<T[]>;
  visible: boolean;
  onClose: () => void;
  filename: string;
  from: string;
}) {
  const {filename} = args

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<T[]>([]);
  const [exportReason, setExportReason] = useState("");
  const {isSubmitting, handleLog} = useDownloadLog();

  useEffect(() => {
    if (!args.visible) {
      return;
    }

    fetch().then(() => {
      console.debug("Fetch done");
    });
  }, [args.visible]);

  async function fetch() {
    setLoading(true);

    await args.fetch().then(setData);

    setLoading(false);
  }

  async function handleDownload(_, done) {
    if (loading || !exportReason.trim()) {
      return done(false);
    }

    handleLog(exportReason, filename, data.length);
    
    try {
      // 추출 사유를 서버에 보내는 API 호출
      await AdminApi.post(`log/export`, {
        reason: exportReason,
        dataType: filename,
        count: data.length,
        timestamp: new Date().toISOString()
      });
    } catch (error) {
      console.error("Export log API error:", error);
    } finally {
      done(true);
      args.onClose();
    }
  }

  function Downloading() {
    return (
      <Space
        direction={"vertical"}
        align={"center"}
        style={{width: "100%"}}
      >
        <Spin/>
      </Space>
    );
  }

  return (
    <Modal
      visible={args.visible}
      title={"Export to CSV"}
      destroyOnClose={true}
      footer={
        <>
          <Button onClick={args.onClose} style={{ marginRight: 8 }}>
            취소
          </Button>
          <CSVLink
            data={data}
            filename={filename}
            asyncOnClick={true}
            onClick={handleDownload}
            style={{ pointerEvents: !exportReason.trim() ? 'none' : 'auto' }}
          >
            <Button 
              type="primary" 
              disabled={!exportReason.trim() || isSubmitting} 
              loading={isSubmitting}
            >
              다운로드
            </Button>
          </CSVLink>
        </>
      }
      onCancel={args.onClose}
    >
      <div style={{ marginBottom: 16 }}>
        {loading ? <Downloading/> : ""}
      </div>
      
      <div style={{ marginTop: 16 }}>
        <p style={{ marginBottom: 8 }}>추출 사유: (필수)</p>
        <Input
          onChange={(e) => setExportReason(e.target.value)}
          placeholder="추출 사유를 입력해주세요"
          style={{ width: '100%' }}
        />
      </div>
    </Modal>
  );
}
